<template>
  <div class="img-progress">
    <!-- 底层：背景图 -->
    <img src="../assets/progress_bg.png" class="bg-img" alt="" />

    <!-- 上层：进度图（核心：动态width） -->
    <div class="active-box">
      <img src="../assets/progress-active.png" class="active-img" :style="{ width: progress + '%' }" alt=""/>
    </div>
    <div class="progress_state">
      <img src="../assets/progress_type1.png" class="bg-img" v-if="progress<100" alt="" />
      <img src="../assets/progress_type2.png" class="bg-img" v-else alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    // 奖品等级：1-一等奖, 2-二等奖, 3-三等奖, 0-未中奖
    ProgressData: {
      type: Number,
      default: 0
    }
  },
  watch: {
    ProgressData: {
      handler(val) {
        this.progress = val
      },
      immediate: true  //组件创建时立即执行
    }
  },
  data() {
    return {
      progress: 0 // 0~100
    }
  },

  mounted() {
    // let timer = setInterval(() => {
    //   this.progress += 1
    //   if (this.progress >= 100) clearInterval(timer)
    // }, 10)
  }
}
</script>

<style scoped>
.img-progress {
  width: 76%;   /* 进度条总宽度 */
  position: absolute;
  left: 12%;
  bottom:0;
  z-index: 9;
}
.bg-img{
  width: 100%;
}
 .active-box {
  width: 82%;
  height: 35%;
  position: absolute;
  top: 24%;
  left:9%;
}

.active-img {
  height: 100%;
  overflow: hidden; /* 只显示进度宽度 */
}
.progress_state{position: absolute; top:0;}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue